import { render, staticRenderFns } from "./integrationsItemList.vue?vue&type=template&id=cef19c0a&scoped=true&"
import script from "./integrationsItemList.vue?vue&type=script&lang=js&"
export * from "./integrationsItemList.vue?vue&type=script&lang=js&"
import style0 from "./integrationsItemList.vue?vue&type=style&index=0&id=cef19c0a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef19c0a",
  null
  
)

export default component.exports